import { zodValidator, type TypedFetch } from "@spiriidk/utils";

import {
  CompaniesSearchSchema,
  CompanyListSchema,
  CompanyPageSchema,
  type CompaniesSearch,
} from "../schemas/company";

const getCompanies = async (
  fetch: TypedFetch,
  query: CompaniesSearch = {},
  signal?: AbortSignal
) =>
  fetch.get("/companies/", {
    validateResponse: zodValidator(CompanyListSchema),
    validateSearch: zodValidator(CompaniesSearchSchema, query),
    signal,
  });

const getCompaniesPage = async (
  fetch: TypedFetch,
  query: CompaniesSearch = {},
  signal?: AbortSignal
) =>
  fetch.get("/companies/", {
    validateResponse: zodValidator(CompanyPageSchema),
    validateSearch: zodValidator(CompaniesSearchSchema, query),
    signal,
  });

export { getCompanies, getCompaniesPage };
